import clsx from 'clsx';
import Button from '../../../components/atoms/button';
import Input from '@/components/atoms/input';
import * as ViewModel from '@/core/presenter/viewModel';
import { MAX_PHONE_NUMBER_LENGTH } from '@/consts';
import { useState } from 'react';

interface IProps {
  phoneNumber: string;
  password: string;
  disabled: boolean;
  isSaveIdChecked: boolean;
  onChangePhoneNumber: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onChangePassword: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  handleSaveIdChange: (isChecked: boolean) => void;
}

const LoginForm = ({
  phoneNumber,
  password,
  disabled,
  isSaveIdChecked,
  onChangePhoneNumber,
  onChangePassword,
  onSubmit,
  handleSaveIdChange,
}: IProps): JSX.Element => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const onChangePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  return (
    <form onSubmit={onSubmit} autoComplete="off">
      <div className="form-group-logn">
        <label htmlFor="phone" className="body-n-n fw-b">
          휴대폰번호를 입력해주세요
        </label>
        <Input
          type="text"
          className="login-input"
          value={phoneNumber}
          validatorType={ViewModel.InputValidatorType.NUMBER_ONLY}
          onChange={onChangePhoneNumber}
          maxLength={MAX_PHONE_NUMBER_LENGTH}
        />
      </div>
      <div className="chk-area" style={{ marginBottom: '1rem' }}>
        <input
          type="checkbox"
          className="body-s"
          id="cbox1"
          checked={isSaveIdChecked}
          onChange={(e) => handleSaveIdChange(e.target.checked)}
        />
        <label style={{ marginLeft: '1rem' }} htmlFor="cbox1" className="txt-label body-s">
          아이디 저장
        </label>
      </div>
      <div className="form-group-logn">
        <label htmlFor="password" className="body-n-n fw-b">
          비밀번호를 입력해주세요
        </label>
        <div className="input-area">
          <Input
            type={isPasswordVisible ? 'text' : 'password'}
            className="login-input"
            value={password}
            validatorType={ViewModel.InputValidatorType.PASSWORD}
            onChange={onChangePassword}
          />
          <i
            className={clsx({ 'bi bi-eye-slash': !isPasswordVisible, 'bi bi-eye': isPasswordVisible })}
            id="togglePassword"
            onClick={onChangePasswordVisibility}
          ></i>
        </div>
      </div>
      <Button
        type="submit"
        caption="로그인"
        className={clsx('glass-button body-n-n fw-b', { enabled: !disabled, default_cursor: disabled })}
        onClick={() => {}}
      />
    </form>
  );
};

export default LoginForm;
